<a *ngIf="data" [href]="fileUrl" class="btn btn-primary" download="{{ fileName }}.pdf">Descargar Documento Cierre</a>